import React, { useState } from 'react';
import EventImage from '../assets/img/event.jpg';
import '../assets/css/Contact.css';
import { Helmet } from 'react-helmet';
import Markdown from 'react-markdown';
import { useGetEventContent } from '../hooks/useGetEventContent';

export const Events = (): JSX.Element => {

    const locale = localStorage.getItem("locale") || "sv";
    const { content } = useGetEventContent(locale);

    const [result, setResult] = useState("");

    const onSubmit = async (event: any) => {
        event.preventDefault();
        setResult("Sending....");
        const formData = new FormData(event.target);
    
        formData.append("access_key", process.env.REACT_APP_WEB3_FORMS_API!);
    
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formData
        });
    
        const data = await response.json();
    
        if (data.success) {
          setResult("Thank you for you message, we'll get back to you soon!");
          event.target.reset();
        } else {
          console.log("Error", data);
          setResult(data.message);
        }
    };

    return (
        <>
            <Helmet>
                <title>Events | French Group</title>
                <meta name="description" content="Contact us to book your event." />
                <link rel="canonical" href="https://frenchgroup.se/events" />

                <meta property="og:title" content="Events | French Group" />
                <meta property="og:description" content="Contact us to book your event." />
                <meta property="og:url" content="https://frenchgroup.se/events" />
                <meta property="og:type" content="website" />

                <meta name="twitter:title" content="Events | French Group" />
                <meta name="twitter:description" content="Contact us to book your event." />
                <meta name="twitter:url" content="https://frenchgroup.se/events" />
                <meta name="twitter:card" content="summary" />
            </Helmet>
            <section id="contact" className="contact">
                <div className="contact__image-container">
                    <img src={EventImage} alt="Strandbryggan drinks" className="contact__image" />
                </div>
                <div className="contact__content fade-in">
                    <h1>
                        {content?.title}
                    </h1>
                    <Markdown>
                        {content?.first_paragraph}
                    </Markdown>
                    <form onSubmit={onSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">
                                {content?.name_label}
                            </label>
                            <input type="text" id="name" name="name" placeholder={content?.name_placeholder} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input type="email" id="email" name="email" placeholder={content?.email_placeholder} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">
                                {content?.event_label}
                            </label>
                            <textarea id="message" name="message" 
                                    placeholder={content?.event_placeholder} 
                                    rows={4}
                                    required></textarea>
                        </div>
                        <button type="submit" className="btn__primary">
                            {content?.button_text}
                        </button>
                        <p className="form__result">{result}</p>
                    </form>
                </div>
            </section>
        </>
    )
}
